import { VisionaryScene } from '@/visionaryControllers/visionaryScene';
import * as THREE from 'three';
import { globalConfig, globalManager } from '@/utils/globalConfig';
import { VisFrameInfo } from '@/visionaryControllers/animationController';

class AnimationUtils {
    // 记录动画相关的内容，帧索引等，主要用来同步UI更新
    private currentFrameIndex: number = 0;
    private totalFrames: number = 0;
    private frameRate: number = 0;
    private isPaused: boolean = false;
    private isLooping: boolean = false;
    private isReversed: boolean = false;
    private isLoopBackwards: boolean = false;

    // 更新所有的animationController的currentFrameIndex,同步更新scene上的渲染
    handleUpdateFrameIndex(frameIndex: number) {
        this.currentFrameIndex = frameIndex;
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.animationController.goToAnimationFrameByIndex(frameIndex);
        });
    }

    // 添加关键帧，回调函数设置add按钮为添加状态
    handleAddKeyframe(frameIndex: number) {
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.animationController.addKeyframe(frameIndex);
            // console.log('场景设置 相机速度改变onSpeedChange', value);
        });
    }
    // 删除关键帧
    handleDeleteKeyframe(frameIndex: number) {
        console.log('*********utils 删除关键帧----', frameIndex);
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.animationController.deleteGlobalKeyframe(frameIndex);
            // console.log('场景设置 相机速度改变onSpeedChange', value);
        });
    }
    // 设置帧率
    setFrameRate(frameRate: number) {
        globalConfig.frameRate = frameRate;
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.animationController.setFrameRate(frameRate);
        });
    }
    // 设置总帧数
    setTotalFrames(totalFrames: number) {
        globalConfig.totalFrames = totalFrames;
        const sceneViews = globalManager.getAllSceneInfos();
        sceneViews.forEach(sceneView => {
            sceneView.animationController.setTotalFrames(totalFrames);
        });
    }
    getTotalFrames() {
        return globalConfig.totalFrames;
    }
    // 获取所有场景的globalKeyframes - 场景相机同步，所以从一个里面获取即可
    getGlobalKeyframesByExistScene() {
        const sceneViews = globalManager.getAllSceneInfos();
        const globalKeyframes: VisFrameInfo[] = [];
        if (sceneViews.length > 0) {
            const sv = sceneViews[0];
            sv.animationController.getGlobalKeyframes().forEach(keyframe => {
                globalKeyframes.push(new VisFrameInfo(keyframe.index));
                // keyframe.objects=[]
            });
        }
        return globalKeyframes;
    }
}

const animationUtils = new AnimationUtils();
export { animationUtils };
